module.exports = __webpack_public_path__ + "dist/media/logo--en.30b933cc.svg";